/* eslint-disable no-nested-ternary, implicit-arrow-linebreak */
import dayjs from '@/utils/dayjs';

// Sat Sept 13, 2022
const formatDate = (dateString, showWeekday = true) => dayjs(dateString).format(`${showWeekday ? 'ddd' : ''} MMM D, YYYY`);

const formatWeekDay = (dateString) => dayjs(dateString).format('dddd');

// 5:30PM CT
const formatTime = (dateString) => dayjs(dateString).format('h:mm A z');

// 5:30PM
const formatTime2 = (dateString) => dayjs(dateString).format('h:mm A');

// sameDay :: DateString -> DateString -> Boolean
const sameDay = (startDateString) => (endDateString) => dayjs(startDateString).isSame(endDateString, 'day');

// September 13-14, 2022
const formatRange = (startDate) => (endDate) =>
  (!dayjs(startDate).isSame(endDate, 'year')
    ? `${dayjs(startDate).format('MMMM D, YYYY')} - ${dayjs(endDate).format('MMMM D, YYYY')}`
    : !dayjs(startDate).isSame(endDate, 'month')
      ? `${dayjs(startDate).format('MMMM D')} - ${dayjs(endDate).format('MMMM D')}, ${dayjs(startDate).format('YYYY')}`
      : !dayjs(startDate).isSame(endDate, 'day')
        ? `${dayjs(startDate).format('MMMM D')} - ${dayjs(endDate).format('D')}, ${dayjs(startDate).format('YYYY')}`
        : dayjs(startDate).format('MMMM D, YYYY'));

const isBetween = (startDate) => (endDate) => (date) =>
  dayjs(date).isBetween(dayjs(startDate), dayjs(endDate));

const rangeBefore = (range, unit) => (startDate) =>
  isBetween(dayjs(startDate).subtract(range, unit))(dayjs(startDate));

const isAfter = (referenceDate) => (date) => dayjs(date).isAfter(referenceDate);

export {
  formatDate,
  formatWeekDay,
  formatTime,
  formatTime2,
  formatRange,
  sameDay,
  rangeBefore,
  isAfter,
};
